import { render, staticRenderFns } from "./bottom-button.vue?vue&type=template&id=54804bb2"
import script from "./bottom-button.vue?vue&type=script&lang=js"
export * from "./bottom-button.vue?vue&type=script&lang=js"
import style0 from "./bottom-button.vue?vue&type=style&index=0&id=54804bb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports